/** Shared label for product search Autocomplete options (API shape may vary). */
export const getSearchOptionLabel = (option) => {
  if (!option?.params) return "";
  const p = option.params;
  const desc = p.Description ?? p.description ?? "";
  const code = p.ItemCode ?? p.itemCode ?? "";
  const part = p.PartNumber ?? p.partNumber ?? "";
  return `${desc} (${part} - ${code})`.trim();
};
